
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../system/mixins";
import { EntityFilterParameter } from "../../../system/filters";
import { DomainRegistry } from "../../../../domain";
import { Department } from "../../../../domain/department";
import { UserFilterParameter } from "..";

@Component({
})
export default class DepartmentUserFilterableMixin extends Mixins(ModelEditableMixin) {
  editingSource: UserFilterParameter;

  @Prop()
  department: Department;

  get departmentSource(): Department {
    return this.department;
  }

  set departmentSource(source: Department) {
    this.$emit("update:department", source);
  }

  @Watch("department", { immediate: true })
  onDepartmentUserFilterableMixinDepartmentChanged(newValue: Department, oldValue: Department) {
    this.updateDepartmentUsers();
  }

  updateDepartmentUsers(): void {
    if (this.department) {
      this.getDepartmentUsers(this.department);
    } else {
      this.departmentUsers = new EntityFilterParameter(null);
    }
  }

  get departmentUsers(): EntityFilterParameter {
    return this.editingSource.departmentUsers;
  }

  set departmentUsers(source: EntityFilterParameter) {
    this.writeProperty(s => s.departmentUsers = source);
  }

  private async getDepartmentUsers(department: Department) {
    try {
      const repository = DomainRegistry.user.getUserRepository();
      const result = await repository.getDepartmentUsers(department.id, this.$configuration.behavior.user.finder.shouldFilterDepartmentUsersByMainDepartment);
      this.departmentUsers = new EntityFilterParameter(result);
    } catch (e) {
      this.$error(
        "職員情報取得失敗",
        "職員情報を取得できませんでした。",
        e,
      );
      this.departmentUsers = new EntityFilterParameter(null);
    }
  }
}
